import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "accordion-container tw-w-full tw-bg-inherit" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  id: "accordion-slot-head",
  class: "tw-pl-2"
}
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablerChevronDown = _resolveComponent("TablerChevronDown")!
  const _component_TablerChevronRight = _resolveComponent("TablerChevronRight")!
  const _component_TablerGripVertical = _resolveComponent("TablerGripVertical")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-sticky tw-top-0 tw-z-10 tw-bg-white tw-py-1 dark:tw-bg-black ${
        _ctx.disabled ? 'tw-cursor-not-allowed' : ''
      } ${_ctx.extraClasses ? _ctx.extraClasses : ''}`)
    }, [
      _createElementVNode("button", {
        "data-testid": "accordion-toggle-button",
        class: "tw-flex tw-w-full tw-items-center tw-text-left",
        disabled: _ctx.disabled,
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleToggleAccordion && _ctx.handleToggleAccordion(...args)), ["stop"]))
      }, [
        (_ctx.chevronPosition === 'left')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.open)
                ? (_openBlock(), _createBlock(_component_TablerChevronDown, {
                    key: 0,
                    class: "tw-h-5 tw-w-5"
                  }))
                : (_openBlock(), _createBlock(_component_TablerChevronRight, {
                    key: 1,
                    class: "tw-h-5 tw-w-5"
                  }))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "head")
        ]),
        (_ctx.chevronPosition === 'right')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.open)
                ? (_openBlock(), _createBlock(_component_TablerChevronDown, {
                    key: 0,
                    class: "tw-h-5 tw-w-5"
                  }))
                : (_openBlock(), _createBlock(_component_TablerChevronRight, {
                    key: 1,
                    class: "tw-h-5 tw-w-5 -tw-rotate-90"
                  }))
            ]))
          : _createCommentVNode("", true),
        (_ctx.draggable)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "drag-handle tw-ml-auto tw-cursor-grab active:tw-cursor-grabbing",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createVNode(_component_TablerGripVertical, { class: "tw-h-5 tw-w-5 tw-text-slate-300" })
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2)
    ], 2),
    _createVNode(_Transition, {
      name: "accordion-details",
      onBeforeEnter: _ctx.beforeEnter,
      onEnter: _ctx.enter,
      onBeforeLeave: _ctx.beforeLeave,
      onLeave: _ctx.leave,
      onAfterEnter: _ctx.onAfterEnter
    }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["accordion-details-body tw-pt-4", _ctx.detailsExtraClasses])
            }, [
              _renderSlot(_ctx.$slots, "details")
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["onBeforeEnter", "onEnter", "onBeforeLeave", "onLeave", "onAfterEnter"])
  ]))
}